<!--
 * A common file wich will fetch data from server
 * Based on fetch data will create a form
-->
<template>
  <div class="position-relative">
    <tool-bar :title="toolbarTitle"></tool-bar>

    <loading :loading="loading"></loading>

    <error-alert-item
        :error-alert-event="errorAlertEvent"
        :network-error="networkError"
        @resetErrorAlertEvent="errorAlertEvent = false"
    ></error-alert-item>

    <stage-comment-item></stage-comment-item>

    <refresh-item
        :show="showRefreshItem"
        @onRefresh="fetchInitialData"
    ></refresh-item>

    <file-attach-button
        v-show="false"
        file-attach-button-id="attachBulkUploadFile"
        text="Attach"
        ref="attachBulkUploadFile"
        @filesAttached="onBulkUploadFileAttached($event.files[0])"
    ></file-attach-button>

    <div v-show="pageDataLoaded" class="margin-top-20 margin-bottom-60">

      <div class="item-heading-desc-div margin-left-10 margin-right-10" v-if="taskHeading">
        <weex-text class="item-sm-heading" v-html="taskHeading"></weex-text>
      </div>

      <data-table-data-layout
          :show="showDataTableDataLayout"
          @onDataTableDataSelected="onDataTableDataSelected"
          @onFilteredJsonElements="onFilteredJsonElements"
          ref="dataTableDataLayoutRef"
      ></data-table-data-layout>

      <data-table-row-layout
          v-if="showDataTableRowLayout"
          :show="showDataTableRowLayout"
          :allow-delete="false"
          :allow-dismiss="!attributeTable && multiRowTable"
          :attribute-table="attributeTable"
          :multi-row-table="multiRowTable"
          :only-for-showing-data="false"
          :process-data-one-by-one="processDataOneByOne"
          :show-all-fields="showAllFields"
          :single-row-table="!multiRowTable"
          :entity-id="entityId"
          :entity-type="entityType"
          :data-table-name="dataTableName"
          :master-data-field-mapping="masterDataFieldMapping"
          :data-table-template-prop="dataTableTemplate"
          :field-data-list-prop="combinedStageAndFilterFieldDataList"
          :json-element-prop="jsonElement"
          :json-elements-prop="jsonElements"
          :row-id-prop="rowId"
          :current-row-index="currentRowIndex"
          :last-row-index="lastRowIndex"
          :file-upload-on-attachment="false"
          ref="dataTableRowLayoutRef"
          @onFetchMasterDataFromServer="onFetchMasterDataFromServer"
          @onSaveAttributeDetails="onSaveAttributeDetails"
          @onSaveOrUpdateSingleRowDataTable="onSaveOrUpdateSingleRowDataTable"
          @onSaveOrUpdateMultiRowDataTable="onSaveOrUpdateMultiRowDataTable"
          @onDismissFormButtonClicked="onDismissFormButtonClicked"
          @onNextRowClicked="onNextRowClicked"
          @onPreviousRowClicked="onPreviousRowClicked"
          @onCompleteFormClicked="onCompleteFormClicked"
      ></data-table-row-layout>

      <table class="data-table-stage-config-buttons-item" v-if="showButtons">
        <tr>
          <td v-if="true">
            <wxc-button
                text="Next"
                class="horizontal-center"
                type="blue"
                @wxcButtonClicked="onNextButtonClicked"
            ></wxc-button>
          </td>
        </tr>
      </table>

      <!--Add new form for multi-row table-->
      <add-button-dialog
          :show="showAddNewEntryIcon"
          @onAddButtonClicked="addNewFormButtonClicked"
      ></add-button-dialog>

    </div>
  </div>
</template>
<script>
import Loading from "../layout/Loading";
import ErrorAlertItem from "../layout/ErrorAlertItem";
import ToolBar from "../layout/ToolBar";
import LoanScopeDataHolder from "../../data/model/LoanScopeDataHolder";
import DataSource from "../../data/DataSource";
import StageCommentItem from "../layout/StageCommentItem";
import RefreshItem from "../layout/RefreshItem";
import LoanTasksUtility from "@/utils/LoanTasksUtility";
import {EntityType} from "@/utils/EntityType";
import EzUtils from "@/utils/EzUtils";
import DataTableDataLayout from "@/components/layout/DataTableDataLayout";
import DataTableRowLayout from "@/components/layout/DataTableRowLayout";
import DeepClone from "lodash.clonedeep";
import LoanTasksActivityNavigator from "@/utils/LoanTasksActivityNavigator";
import AddButtonDialog from "@/components/dialogs/AddButtonDialog";
import WxcButton from "../../../weex-ui/packages/wxc-button/index";
import {Constants} from "@/components/Constants";
import FileAttachButton from "@/components/layout/FileAttachButton";
import AlertService from "@/components/core/alert/AlertService";

export default {
  name: "DataTablesDataConfigActivity",
  components: {
    ToolBar,
    Loading,
    ErrorAlertItem,
    DataTableRowLayout,
    StageCommentItem,
    RefreshItem,
    DataTableDataLayout,
    AddButtonDialog,
    WxcButton,
    FileAttachButton
  },

  data: () => ({
    loading: false,
    errorAlertEvent: false,
    networkError: {},
    showRedirectMessageDialog: false,
    showRefreshItem: false,
    currentLoanTaskEnum: null,
    pageDataLoaded: false,

    showDataTableDataLayout: false,
    showDataTableRowLayout: false,
    addingNewEntryAllowed: true,
    currentRowIndex: -1,
    taskHeading: "",

    //Data config activity provider variables
    toolbarTitle: "",
    dataTableStageConfig: {},
    dataTableTemplate: {},
    dataTableName: "",
    jsonElements: [],
    jsonElement: {},
    filteredJsonElements: [],
    description: "",
    numberOfEntriesConstraint: "",
    entityId: -1,
    rowId: -1,
    entityType: "",
    attributeTable: false,
    multiRowTable: false,
    showAllFields: false,
    disableAddingNewEntry: false,
    callServerOnRowEvent: false,
    refreshOnRowEvent: false,
    processDataOneByOne: false,
    readOnly: false,
    bulkUpload: null,
    headerFieldDataList: [],
    stageFieldDataList: [],
    filterFieldDataList: [],
    combinedStageAndFilterFieldDataList: [],
    masterDataFieldMapping: {}
  }),

  methods: {
    showToast(message) {
      AlertService.showToast(message);
    },

    showError(error) {
      this.loading = false;
      this.networkError = error;
      this.errorAlertEvent = true;
    },

    onDataTableDataSelected(currentRowindex, jsonElement) {
      this.currentRowIndex = currentRowindex;
      this.createForm(
          EzUtils.getFieldValueForColumnName("id", jsonElement),
          jsonElement,
          null
      );
    },

    onFilteredJsonElements(filteredJsonElements) {
      this.filteredJsonElements = filteredJsonElements;

      if (EzUtils.isNotEmpty(this.filteredJsonElements)
          && this.numberOfEntriesConstraint === Constants.ONE
      ) {
        this.addingNewEntryAllowed = false;
      } else {
        this.addingNewEntryAllowed = true;
      }
    },

    createForm(rowId, jsonElement, jsonElements) {
      this.showDataTableDataLayout = false;
      this.showDataTableRowLayout = true;

      this.rowId = rowId ? rowId : -1;
      this.jsonElement = jsonElement ? DeepClone(jsonElement) : {};
      this.jsonElements = jsonElements ? DeepClone(jsonElements) : [];
    },

    onBulkUploadFileAttached(file) {
      if (file) {
        this.loading = true;
        const documentName = this.bulkUpload["bulk_upload_document_type"];
        DataSource.createDocument(
            this.entityType,
            this.entityId,
            documentName,
            "Bulk Upload",
            documentName,
            file,
            false
        )
        .then(createDocumentRes => {
          if (createDocumentRes.errorOccurred) {
            this.showError(createDocumentRes.data);
          } else {
            DataSource.bulkUploadRows({
              entity_type: this.entityType,
              entity_id: this.entityId,
              data_table_name: this.dataTableName,
              document_name: documentName,
              upload_mode: this.bulkUpload["upload_mode"],
            })
            .then(bulkUploadRes => {
              this.loading = false;
              if (bulkUploadRes.errorOccurred) {
                this.showError(bulkUploadRes.data);
              } else {
                const ezCredResponseStatus = bulkUploadRes.data;
                if (ezCredResponseStatus) {
                  if (Constants.SUCCESS === ezCredResponseStatus["status"]) {
                    this.showToast("Document uploaded.");
                    this.taskHeading = this.description;
                    this.fetchMultiRowDataTableAndShowData();
                  } else if (Constants.FAILURE === ezCredResponseStatus["status"]) {
                    let failureMessage = "";
                    if (EzUtils.isNotEmpty(ezCredResponseStatus["errors"])) {
                      failureMessage = ezCredResponseStatus["errors"][0]["message"];
                    }
                    if (failureMessage) {
                      this.taskHeading = failureMessage;
                    }
                  }
                }
              }
            })
          }
        })
      }
    },

    processExistingRecordsBasedOnDataTable() {
      if (this.attributeTable || !this.multiRowTable) {
        if (this.attributeTable) {
          this.createForm(-1, null, this.jsonElements);
        } else {
          const jsonElement = EzUtils.isNotEmpty(this.jsonElements) ? this.jsonElements[0] : null;
          this.createForm(-1, jsonElement, null);
        }
      } else {
        this.showDataTableData();
      }
    },

    onNextButtonClicked() {
      if (this.checkForValidation()) {
        this.completeCurrentTaskAndGetNextTask();
      }
    },

    checkForValidation() {
      if (this.numberOfEntriesConstraint && EzUtils.isEmpty(this.filteredJsonElements)) {
        this.showToast("Please add details.");
        return false;
      }

      if (this.dataTableStageConfig["update_all_entries"]
          && EzUtils.isNotEmpty(this.dataTableStageConfig["status_column_name"])
          && EzUtils.isNotEmpty(this.dataTableStageConfig["completed_status_list"])
          && EzUtils.isNotEmpty(this.filteredJsonElements)
      ) {
        for (let i = 0, n = this.filteredJsonElements.length; i < n; i++) {
          const jsonElement = this.filteredJsonElements[i];
          const status = EzUtils.getFieldValueForColumnName(
              this.dataTableStageConfig["status_column_name"],
              jsonElement
          );

          if (!status || !this.dataTableStageConfig["completed_status_list"].includes(status)) {
            this.showToast("Please update details for all entries.");
            return false;
          }
        }
      }

      return true;
    },

    /**
     * On add button clicked <br>
     * Open new form based on field data
     */
    addNewFormButtonClicked() {
      if (this.bulkUpload) {
        this.$refs.attachBulkUploadFile.attachFile();
      } else {
        this.createForm(-1, null, null);
      }
    },

    fetchInitialData() {
      this.loading = true;
      this.showRefreshItem = false;

      LoanTasksUtility.getLoanStageConfigData(LoanScopeDataHolder.getLoanId(), this.currentTaskName)
      .then(stageConfigRes => {
        if (stageConfigRes.errorOccurred) {
          this.showRefreshItem = true;
          this.showError(stageConfigRes["data"]);
        } else {
          //call setComponentData method before calling subsequent APIS
          this.setComponentData(stageConfigRes["data"]);

          if (!this.dataTableName) {
            this.loading = false;
            return;
          }

          DataSource.getDataTableByDataTableName(this.dataTableName)
          .then(dataTableTemplateRes => {
            if (dataTableTemplateRes.errorOccurred) {
              this.showRefreshItem = true;
              this.showError(dataTableTemplateRes.data);
            } else {
              this.dataTableTemplate = dataTableTemplateRes.data;

              DataSource.getDataTableInfo(this.dataTableName, this.entityId)
              .then(dataTableRes => {
                this.loading = false;
                if (dataTableRes.errorOccurred) {
                  this.showRefreshItem = true;
                  this.showError(dataTableRes.data);
                } else {
                  this.jsonElements = dataTableRes.data;
                  this.pageDataLoaded = true;
                  this.processExistingRecordsBasedOnDataTable();
                }
              })
            }
          })
        }
      })
    },

    setComponentData(dataTableStageConfig) {
      if (dataTableStageConfig) {
        this.dataTableStageConfig = dataTableStageConfig;
      } else {
        this.dataTableStageConfig = {};
      }

      //default to loans`
      this.entityType = EntityType.LOANS;
      this.entityId = LoanScopeDataHolder.getLoanId();

      if (EzUtils.isNotEmpty(this.dataTableStageConfig["entity_type"])) {
        this.entityType = this.dataTableStageConfig["entity_type"];
      }

      if (this.entityType === EntityType.CLIENTS) {
        this.entityId = LoanScopeDataHolder.getClientId();
      }

      this.stageFieldDataList = this.getDataTableStageConfigValue("field_data_list", []);
      this.headerFieldDataList = this.getDataTableStageConfigValue("header_field_data_list", []);
      this.filterFieldDataList = this.getDataTableStageConfigValue("filter_field_data_list", []);
      this.attributeTable = this.getDataTableStageConfigValue("attributes_table", false);
      this.multiRowTable = this.getDataTableStageConfigValue("multi_row", false);
      this.showAllFields = this.getDataTableStageConfigValue("show_all_fields", false);
      this.disableAddingNewEntry = this.getDataTableStageConfigValue(
          "disable_adding_new_entry",
          false
      );
      this.callServerOnRowEvent = this.getDataTableStageConfigValue(
          "call_server_on_row_event",
          false
      );
      this.refreshOnRowEvent = this.getDataTableStageConfigValue("refresh_on_row_event", false);
      this.processDataOneByOne = this.getDataTableStageConfigValue(
          "process_data_one_by_one",
          false
      );
      this.readOnly = this.getDataTableStageConfigValue("read_only", false);
      this.bulkUpload = this.getDataTableStageConfigValue("bulk_upload", null);
      this.toolbarTitle = this.getDataTableStageConfigValue("title", "");
      this.description = this.getDataTableStageConfigValue("description", "");
      this.numberOfEntriesConstraint = this.getDataTableStageConfigValue(
          "number_of_entries_constraint",
          ""
      );
      this.dataTableName = this.getDataTableStageConfigValue("data_table_name", "");
      this.masterDataFieldMapping = this.getDataTableStageConfigValue(
          "master_data_field_mapping",
          {}
      );

      this.taskHeading = this.description;

      if (EzUtils.isNotEmpty(this.stageFieldDataList)) {
        this.combinedStageAndFilterFieldDataList.push(...DeepClone(this.stageFieldDataList));
      }

      if (EzUtils.isNotEmpty(this.filterFieldDataList)) {
        const filterFieldDataListCopy = DeepClone(this.filterFieldDataList);
        filterFieldDataListCopy.forEach(filterFieldDataCopy => {
          filterFieldDataCopy["hide"] = true;
        });
        this.combinedStageAndFilterFieldDataList.push(...DeepClone(filterFieldDataListCopy));
      }
    },

    getDataTableStageConfigValue(key, defaultValue) {
      let value = defaultValue;
      if (this.dataTableStageConfig
          && (typeof this.dataTableStageConfig[key] === "boolean" || this.dataTableStageConfig[key])
      ) {
        value = this.dataTableStageConfig[key];
      }

      return value;
    },

    onFetchMasterDataFromServer(masterDataRequestDtoMap) {
      this.loading = true;

      DataSource.getMasterValuesForMap(masterDataRequestDtoMap)
      .then(masterValuesRes => {
        this.loading = false;
        if (masterValuesRes.errorOccurred) {
          this.showError(masterValuesRes.data)
        } else {
          if (this.$refs.dataTableRowLayoutRef) {
            this.$refs.dataTableRowLayoutRef.onMasterDataFetched(masterValuesRes.data);
          }
        }
      })
    },

    onSaveAttributeDetails(attributeData) {
      this.loading = true;

      DataSource.createOrUpdateAttribute(attributeData)
      .then(attributeDataRes => {
        this.loading = false;
        if (attributeDataRes.errorOccurred) {
          this.showError(attributeDataRes.data);
        } else {
          this.completeCurrentTaskAndGetNextTask();
        }
      })
    },

    onSaveOrUpdateSingleRowDataTable(entityId, dataTableName, payload) {
      this.loading = true;
      DataSource.getDataTableInfo(dataTableName, entityId)
      .then(dataDetailsRes => {
        if (dataDetailsRes.errorOccurred) {
          this.showError(dataDetailsRes.data);
        } else {
          if (EzUtils.isNotEmpty(dataDetailsRes.data)) {
            DataSource.updateDataTableEntry(dataTableName, entityId, payload)
            .then(updateRes => {
              this.loading = false;
              if (updateRes.errorOccurred) {
                this.showError(updateRes.data);
              } else {
                this.completeCurrentTaskAndGetNextTask();
              }
            })
          } else {
            DataSource.addDataTableEntry(dataTableName, entityId, payload)
            .then(saveRes => {
              this.loading = false;
              if (saveRes.errorOccurred) {
                this.showError(saveRes.data);
              } else {
                this.completeCurrentTaskAndGetNextTask();
              }
            })
          }
        }
      })
    },

    onSaveOrUpdateMultiRowDataTable(rowId, entityId, dataTableName, payload) {
      this.loading = true;

      if (EzUtils.isValidId(rowId)) {
        DataSource.updateDataTableEntryInMultiRowDataTable(dataTableName, entityId, rowId, payload)
        .then(updateRes => {
          this.loading = false;
          if (updateRes.errorOccurred) {
            this.showError(updateRes.data);
          } else {
            this.onMultiRowDataTableEvent(Constants.UPDATE, updateRes.data);
          }
        })
      } else {
        DataSource.addDataTableEntry(dataTableName, entityId, payload)
        .then(saveRes => {
          this.loading = false;
          if (saveRes.errorOccurred) {
            this.showError(saveRes.data);
          } else {
            this.onMultiRowDataTableEvent(Constants.CREATE, saveRes.data);
          }
        })
      }
    },

    onMultiRowDataTableEvent(eventType, genericResponse) {
      if (this.callServerOnRowEvent) {
        this.loading = true;
        DataSource.notifyDataTableEvent(this.dataTableName, eventType, genericResponse)
        .then(notifyDataRes => {
          this.loading = false;
          if (notifyDataRes.errorOccurred) {
            this.showError(notifyDataRes.data);
          } else {
            this.onMultiRowDataTableEventNotified(eventType, genericResponse);
          }
        })
      } else {
        this.fetchMultiRowDataTableAndShowData();
      }
    },

    onMultiRowDataTableEventNotified(eventType, genericResponse) {
      if (!this.refreshOnRowEvent || eventType === Constants.DELETE) {
        this.fetchMultiRowDataTableAndShowData();
      } else {
        this.loading = true;
        DataSource.getDataOfDataTableInfoWithFilter(
            this.dataTableName, this.entityId, "id", genericResponse["id"]
        )
        .then(latestRowDataInfoRes => {
          this.loading = false;
          if (latestRowDataInfoRes.errorOccurred) {
            this.showError(latestRowDataInfoRes.data);
          } else {
            const latestRowDataInfo =
                EzUtils.isNotEmpty(latestRowDataInfoRes.data) ? latestRowDataInfoRes.data[0] : null;
            if (latestRowDataInfo) {
              this.$refs.dataTableRowLayoutRef.refreshForm(latestRowDataInfo);
            } else {
              this.fetchMultiRowDataTableAndShowData();
            }
          }
        })
      }
    },

    fetchMultiRowDataTableAndShowData() {
      this.loading = true;
      DataSource.getDataTableInfo(this.dataTableName, this.entityId)
      .then(dataTableRes => {
        this.loading = false;
        if (dataTableRes.errorOccurred) {
          this.showError(dataTableRes.data);
        } else {
          this.jsonElements = dataTableRes.data;
          this.showDataTableData();
        }
      })
    },

    showDataTableData() {
      this.showDataTableRowLayout = false;
      this.showDataTableDataLayout = true;
      this.$refs.dataTableDataLayoutRef.showExistingRecords(
          this.dataTableTemplate,
          this.jsonElements,
          this.headerFieldDataList,
          this.filterFieldDataList
      );
    },

    onCompleteFormClicked() {
      if (this.readOnly && !this.bulkUpload) {
        this.completeCurrentTaskAndGetNextTask();
      } else {
        this.fetchMultiRowDataTableAndShowData();
      }
    },

    onDismissFormButtonClicked() {
      this.fetchMultiRowDataTableAndShowData();
    },

    onNextRowClicked() {
      this.showDataTableRowLayout = false;
      if (this.filteredJsonElements
          && this.filteredJsonElements.length > 0
          && this.currentRowIndex < this.filteredJsonElements.length - 1
      ) {
        this.currentRowIndex++;
        const jsonElement = this.filteredJsonElements[this.currentRowIndex];
        const nextRowId = EzUtils.getFieldValueForColumnName("id", jsonElement);
        if (EzUtils.isValidId(nextRowId)) {
          this.fetchNextOrPreviousRowDataAndCreateForm(nextRowId);
        } else {
          this.fetchMultiRowDataTableAndShowData();
        }
      } else {
        this.fetchMultiRowDataTableAndShowData();
      }
    },

    onPreviousRowClicked() {
      this.showDataTableRowLayout = false;
      if (this.filteredJsonElements
          && this.filteredJsonElements.length > 0
          && this.currentRowIndex > 0
      ) {
        this.currentRowIndex--;
        const jsonElement = this.filteredJsonElements[this.currentRowIndex];
        const previousRowId = EzUtils.getFieldValueForColumnName("id", jsonElement);
        if (EzUtils.isValidId(previousRowId)) {
          this.fetchNextOrPreviousRowDataAndCreateForm(previousRowId);
        } else {
          this.fetchMultiRowDataTableAndShowData();
        }
      } else {
        this.fetchMultiRowDataTableAndShowData();
      }
    },

    fetchNextOrPreviousRowDataAndCreateForm(nextRowId) {
      this.loading = true;
      DataSource.getDataOfDataTableInfoWithFilter(
          this.dataTableName, this.entityId, "id", nextRowId
      )
      .then(latestRowDataInfoRes => {
        this.loading = false;
        if (latestRowDataInfoRes.errorOccurred) {
          this.showError(latestRowDataInfoRes.data);
        } else {
          const latestRowDataInfo =
              EzUtils.isNotEmpty(latestRowDataInfoRes.data) ? latestRowDataInfoRes.data[0] : null;
          if (latestRowDataInfo) {
            this.onDataTableDataSelected(this.currentRowIndex, latestRowDataInfo);
          } else {
            this.fetchMultiRowDataTableAndShowData();
          }
        }
      })
    },

    completeCurrentTaskAndGetNextTask() {
      this.loading = true;
      LoanTasksActivityNavigator.getNextTask([this.currentLoanTaskEnum])
      .then(res => {
        this.loading = false;
        if (res.errorOccurred) {
          this.showError(res.data);
        }
      });
    }
  },

  mounted() {
    this.currentLoanTaskEnum = this.currentTaskName;
    this.fetchInitialData();
  },

  computed: {
    currentTaskName() {
      return LoanScopeDataHolder.getCurrentLoanTask()
          ? LoanScopeDataHolder.getCurrentLoanTask().name
          : "";
    },

    showAddNewEntryIcon() {
      return !this.disableAddingNewEntry
          && this.showDataTableDataLayout
          && this.addingNewEntryAllowed;
    },

    showButtons() {
      return this.showDataTableDataLayout;
    },

    lastRowIndex() {
      return EzUtils.isNotEmpty(this.filteredJsonElements)
          ? this.filteredJsonElements.length - 1 : -1;
    }
  },
};
</script>

<style
    scoped
    src="../../assets/style/base.css"></style>
<style scoped>
.data-table-stage-config-buttons-item {
  table-layout: fixed;
  width: 100%;
  max-width: 450px;
  position: fixed;
  bottom: 5px;
}
</style>
